/** Felder, die in der DB NOT NULL sind und daher NIE auf null gesetzt werden dürfen.
 *  `name` (Firmenname) ist Pflicht — ein null-Name löste einen 500 aus (NOT-NULL-Constraint). */
const REQUIRED_FIELDS = new Set(['name']);

/**
 * Baut den PATCH-Payload für ein Kunden-Update.
 * Geleerte Felder ('') werden zu `null`, damit sie serverseitig wirklich geleert werden —
 * AUSSER Pflichtfeldern (name): ist der Wert leer/nur Leerzeichen, wird das Feld ganz
 * WEGGELASSEN (nicht gesendet), damit der bestehende Name erhalten bleibt und kein
 * NOT-NULL-Fehler entsteht. `undefined`-Felder werden ausgelassen (kein Change).
 */
export function buildCustomerUpdatePayload(
  raw: Record<string, unknown>,
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(raw)
      .filter(([, v]) => v !== undefined)
      // Pflichtfeld mit leerem Wert → weglassen (bestehender Wert bleibt erhalten).
      .filter(([k, v]) => !(REQUIRED_FIELDS.has(k) && (v == null || String(v).trim() === '')))
      .map(([k, v]) => [k, v === '' && !REQUIRED_FIELDS.has(k) ? null : v]),
  );
}

/**
 * Baut den POST-Payload für eine Kunden-Neuanlage: entfernt leere Felder
 * ('' / null / undefined), behält alle anderen Werte (auch `false`).
 */
export function buildCustomerCreatePayload(
  raw: Record<string, unknown>,
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(raw).filter(([, v]) => v !== '' && v != null),
  );
}
